// @flow
import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import type { TPlayerWithFixture } from '../../modules/types/player';
import colors from '../../assets/css/colors';
import { below } from '../../assets/css/media';
import { PlayerProfilePopup, PlayerStatus } from '../../components';

const WrapperPlayerInfo = styled.div`
	display: flex;
	margin: ${({ short_opponent }) => short_opponent ? '0 .5em 0 0' : '0 .5em'};
	color: ${colors.darkGrey};
	font-size: 12px;
	${({ short_opponent }) => short_opponent ? 'overflow: hidden;' : ''}
	${({ reverse }) => reverse ? 'flex-direction: row-reverse; text-align: right;' : ''}
`;

const PlayerDetailsInfo = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: ${({ reverse }) => reverse ? 'flex-end' : 'flex-start'};
	padding-left: .5em;

	${below.phone`
		.opponent {
			display: none;
		}
	`}
`;

const PlayerName = styled.p`
	color: ${colors.nrlDarkGreen};
	font-weight: bold;
	font-size: 12px;
	margin-bottom: .5em;
	cursor: pointer;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	${below.tablet`
		max-width: ${({ longer_name }) => longer_name ? '8.5em' : '6.5em'};
	`};
	${below.phone`
		max-width: ${({ longer_name }) => longer_name ? '8.5em' : '5.8em'};;
	`};
`;

const PlayerAvatar = styled.div`
	height: 60px;
	width: 56.52px;
	${({ short_opponent }) => short_opponent ? 'margin-left: -5px;' : ''}
	${({ reverse }) => reverse ? 'margin-left: .5em' : ''}
	${below.desktop`
		height: 50px;
		width: 50px;
	`}

	img {
		max-width: 100%;
		height: 100%;
	}
`;

const PlayerTeamName = styled.b`
	font-weight: bold;
`;

const PlayerDetails = styled.p`
	${below.desktop`
		font-size: 10px;
	`}
`;


type Props = {
	player: TPlayerWithFixture,
	short_opponent?: boolean,
	reverse?: boolean,
	longer_name?: boolean,
	openPopup?: Function,
	closePopup?: Function,
};

type State = {
	player_popup_id?: number,
};

export class PlayerInfo extends React.Component<Props, State> {

	state = {
		player_popup_id: 0,
	};

	constructor() {
		super();

		_.bindAll(this, ['closePlayerPopup','openPlayerPopUp']);
	}

	closePlayerPopup() {
		const { closePopup } = this.props;
		if (closePopup) {
			closePopup();
		}
		else {
			this.setState({
				player_popup_id: 0
			});
		}
	}

	openPlayerPopUp(id: number) {
		const { openPopup } = this.props;
		if (openPopup) {
			openPopup(id);
		}
		else {
			this.setState({
				player_popup_id: id
			});
		}
	}

	render(){
		const { player_popup_id } = this.state;
		const { player, short_opponent, reverse, longer_name } = this.props;

		if(_.isEmpty(player)) {
			return null;
		}

		const is_bye = _.get(player, ['competition', 'is_bye'], false);

		return (
			<WrapperPlayerInfo short_opponent={short_opponent} reverse={reverse} >
				<PlayerAvatar
					short_opponent={short_opponent}
					reverse={reverse}
					className="player-avatar"
				>
					<img
						src={`${process.env.REACT_APP_PLAYERS_PATH + player.id}.png`}
						alt={`${player.first_name[0]}. ${player.last_name}`}
					/>
				</PlayerAvatar>
				<PlayerDetailsInfo reverse={reverse}>
					<PlayerName
						longer_name={longer_name}
						onClick={() => this.openPlayerPopUp(player.id)}
					>
						<PlayerStatus status={player.status} is_bye={is_bye} />
						<span>{`${player.first_name[0]}. ${player.last_name}`}</span>
					</PlayerName>
					<PlayerDetails>
						<span className="opponent">
							{short_opponent ? null : (
								<React.Fragment>
									<PlayerTeamName>
										{_.get(this.props.player.squad, 'short_name')}
									</PlayerTeamName>
									{' '}
								</React.Fragment>
							)}
							{_.get(player.competition, 'symbol')}
							{' '}
							{_.get(player.competition, 'opponent.short_name')}
							{' '}
						|&nbsp;
						</span>
						<span className="positions">
							{_.get(player, 'positions_name', []).join(' / ')}
						</span>
					</PlayerDetails>
				</PlayerDetailsInfo>
				{ player_popup_id ? (
					<PlayerProfilePopup
						player={player}
						closeClick={this.closePlayerPopup}
					/>
				) : null }
			</WrapperPlayerInfo>
		);
	}
}

export default PlayerInfo;


// WEBPACK FOOTER //
// ./src/components/PlayerInfo/index.js